import AcceptIcon from '@/shared/assets/icons/acceptDeal.svg?react'
import { BaseDialog } from '@/shared/components'

type Props = {
  modalVisible: boolean
  setModalVisible: (value: boolean) => void
  onSubmit: () => void
}

export const AcceptDealDialog = ({ modalVisible, setModalVisible, onSubmit }: Props) => {
  const handleClose = () => {
    setModalVisible(false)
  }
  return (
    <BaseDialog
      isVisible={modalVisible}
      onClose={handleClose}
      onAction={onSubmit}
      actionButtonName="Подвердить"
      xButton={false}
      iconTitle={<AcceptIcon className="text-[var(--status-purple-fill)]" />}
    >
      <p className="text-[20px] tracking-[-0.2px] whitespace-normal mt-[-8px]">
        Подтверждаю, что платеж был осуществлен
      </p>
    </BaseDialog>
  )
}
